import React from 'react';
import { Box, Typography, LinearProgress, Tooltip, useTheme } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const gradientColors = (theme) =>
  theme.palette.mode === 'dark'
    ? [
      'linear-gradient(to right,rgb(20, 20, 20), #1a1a1a)', // Too Weak
      'linear-gradient(to right, #4e342e, #3e2723)', // Keep Going
      'linear-gradient(to right, #33691e, #1b5e20)', // Getting Better
      'linear-gradient(to right, #0277bd, #01579b)', // Almost There
      'linear-gradient(to right, #00bcd4, #00838f)', // Super Strong
    ]
    : [
      'linear-gradient(to right, #fbfdff, #ebf5ff)', // Too Weak
      'linear-gradient(to right, #ffebcc, #fff2e6)', // Keep Going
      'linear-gradient(to right, #f0ffcc, #e6ffe9)', // Getting Better
      'linear-gradient(to right, #ccffcc, #e6ffe6)', // Almost There
      'linear-gradient(to right, #cceeff, #e6f7ff)', // Super Strong
    ];
const PasswordStrengthIndicator = ({ passwordStrength, strengthFeedback }) => {
  const theme = useTheme();
  const gradients = gradientColors(theme);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '150px',
        marginLeft: '16px',
        borderRadius: 1,
        border: `1px solid ${theme.palette.divider}`,
        padding: '8px',
        height: '58px',
        background: gradients[passwordStrength],
      }}
    >
      {passwordStrength === 0 ? (
        <Typography
          sx={{
            marginTop: '9px',
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: '14px',
            color: theme.palette.text.primary,
          }}
        >
          Strength
        </Typography>
      ) : (
        <>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>
              {['Weak!', 'Weak!', 'Good enough', 'Strong!', 'Super Strong!'][passwordStrength]}
            </Typography>
            {strengthFeedback.suggestions?.length > 0 && (
              <Tooltip
                placement='top'
                title={
                  <Box>
                    {strengthFeedback.suggestions.map((suggestion, index) => (
                      <Typography key={index} variant="body2" color="inherit">
                        {suggestion}
                      </Typography>
                    ))}
                  </Box>
                }
              >
                <InfoIcon color='action' sx={{ cursor: 'pointer', fontSize: 22 }} />
              </Tooltip>
            )}
          </Box>
          <LinearProgress
            variant="determinate"
            value={(passwordStrength / 4) * 100}
            sx={{
              width: '100%',
              mt: 1,
              '& .MuiLinearProgress-bar': {
                backgroundColor:
                  passwordStrength === 0
                    ? theme.palette.error.main
                    : passwordStrength === 1
                      ? theme.palette.error.main
                      : passwordStrength === 2
                        ? theme.palette.success.light
                        : passwordStrength === 3
                          ? theme.palette.success.main
                          : theme.palette.success.dark,
              },
            }}
          />
        </>
      )}
    </Box>
  );
};

export default PasswordStrengthIndicator;
